import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteModal = ({ show, onClose, onConfirm, message, modalTitle = "Delete Confirm",submitBtnLabel="Delete", cancelBtnLabel="Cancel"}) => {
  return (
    // <Modal show={show} size="md"  onHide={onClose} centered>
    //   <div className="card rounded border-0 m-2">
    //     <Modal.Header>
    //       <Modal.Title className="text-info">
    //         <div className="text-center d-flex justify-center">
    //           <h2 style={{ fontWeight: "800", color: '#2E2E48' }}>
    //             <i className="bi bi-exclamation-triangle-fill icon"></i> Delete Confirm
    //           </h2>
    //         </div>
    //       </Modal.Title>
    //     </Modal.Header>
    //     <Modal.Body
    //       className="rounded m-3"
    //       style={{
    //         maxHeight: "60vh",
    //         overflow: "scroll",
    //         backgroundColor: "white",
    //       }}
    //     >
    //       {message || "Are you sure you want to delete this item?"}
    //     </Modal.Body>
    //     <Modal.Footer>
    //       <button className="btn-info " onClick={onClose}>
    //         Cancel
    //       </button>
    //       <button
    //         className="btn custom-btn text-white"
    //         onClick={onConfirm}
    //       >
    //         Delete
    //       </button>
    //     </Modal.Footer>
    //   </div>
    // </Modal>
    <Modal show={show} size="md" onHide={onClose} centered backdrop="static">
      <div style={{
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
        border: "none",
        overflow: "hidden",
      }}>
        {/* Header with Icon */}
        <Modal.Header style={{
          borderBottom: "none",
          justifyContent: "center",
          paddingBottom: "0",
          paddingTop: "32px",
          backgroundColor: "#ffffff",
        }}>
          <div style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <div style={{
              width: "44px",
              height: "44px",
              backgroundColor: "#fee2e2",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "12px",
              color: "#dc2626",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}>
              <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: "22px" }}></i>
            </div>

            <h3 style={{
              fontWeight: "600",
              color: "#1f2937",
              fontSize: "20px",
              margin: "0",
            }}>
              {modalTitle}

            </h3>
          </div>
        </Modal.Header>

        {/* Body */}
        <Modal.Body style={{
          backgroundColor: "#ffffff",
          padding: "4px 10px",
          fontSize: "15px",
          color: "#6b7280",
          textAlign: "center",
          lineHeight: "1.5",
        }}>
          {message || "Are you sure you want to delete this item? This action cannot be undone."}
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer style={{
          borderTop: "none",
          justifyContent: "center",
          padding: "14px",
          gap: "12px",
          backgroundColor: "#ffffff",
        }}>
          <button
            style={{
              backgroundColor: "#f3f4f6",
              border: "1px solid #e5e7eb",
              padding: "6px 18px",
              borderRadius: "8px",
              fontWeight: "500",
              color: "#374151",
              cursor: "pointer",
              fontSize: "14px",
              transition: "all 0.2s ease",
            }}
            onClick={onClose}
          >
            {cancelBtnLabel}
          </button>
          <button
            style={{
              backgroundColor: "#27568B",
              border: "none",
              padding: "6px 18px",
              borderRadius: "8px",
              fontWeight: "500",
              color: "#ffffff",
              cursor: "pointer",
              fontSize: "14px",
              transition: "all 0.2s ease",
            }}
            onClick={onConfirm}
          >
            {submitBtnLabel}
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};
export default DeleteModal;
